import Api from "../apis/Api";

export default {
	methods: {
		formFields(selectedType = "A", edit = false) {
			let fields = [
				{
					label: this.$t('form.label.type'),
					name: "type",
					tooltip: "tooltip.add_dns_record.type",
					type: "select",
					readonly: edit == true,
					rules: [],
					options: this.recordTypes.items,
					onChange: (values) => {
						switch (values.type) {
							case "A":
							case "AAAA":
								this.$refs.modal.showFields(["address", "proxied"]);
								this.$refs.modal.hideFields([
									"flag",
									"tag",
									"value",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"preference",
									"exchange",
									"nameserver",
									"pointer",
									"rdata"
								]);
								break;
							case "CAA":
								this.$refs.modal.showFields(["flag", "tag", "value"]);
								this.$refs.modal.hideFields([
									"address",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"preference",
									"exchange",
									"proxied",
									"nameserver",
									"pointer",
									"rdata"
								]);
								break;
							case "CNAME":
								this.$refs.modal.showFields(["cname", "proxied"]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"preference",
									"exchange",
									"nameserver",
									"pointer",
									"rdata"
								]);
								break;
							case "SRV":
								this.$refs.modal.showFields([
									"target",
									"weight",
									"port",
									"priority",
									"proxied",
									"nameserver",
									"pointer",
									"rdata"
								]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"cname",
									"txtdata",
									"preference",
									"exchange",
									"proxied",
									"nameserver",
									"pointer",
									"rdata"
								]);
								break;
							case "TXT":
								this.$refs.modal.showFields(["txtdata"]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"preference",
									"exchange",
									"proxied",
									"nameserver",
									"pointer",
									"rdata"
								]);
								break;
							case "MX":
								this.$refs.modal.showFields(["preference", "exchange"]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"proxied",
									"rdata",
									"nameserver",
									"pointer"
								]);
								break;
							case "NS":
								this.$refs.modal.showFields(["nameserver"]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"proxied",
									"preference",
									"exchange",
									"rdata",
									"pointer"
								]);
								break;
							case "PTR":
								this.$refs.modal.showFields(["pointer"]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"proxied",
									"preference",
									"exchange",
									"nameserver",
									"rdata"
								]);
								break;
							default:
								this.$refs.modal.showFields(["rdata"]);
								this.$refs.modal.hideFields([
									"address",
									"flag",
									"tag",
									"value",
									"cname",
									"target",
									"weight",
									"port",
									"priority",
									"txtdata",
									"proxied",
									"preference",
									"exchange",
									"pointer"
								]);
						}
					},
				},
				{
					label: this.$t('form.label.name'),
					name: "name",
					tooltip: "tooltip.add_dns_record.name",
					type: "text",
					rules: [
						(v) => !!v || this.$t('form.validation.required', {field: this.$t('form.label.name')}),
						(v) =>
							(v && v.length <= 255) ||
							this.$t('form.validation.maxLength', {
								field: this.$t('form.label.name'),
								length: 255
							}),
					],
				},
				{
					label: this.$t('form.label.ttl'),
					tooltip: "tooltip.add_dns_record.ttl",
					name: "ttl",
					rules: [
						(v) => !!v || this.$t('form.validation.required', {field: this.$t('form.label.ttl')}),
						(v) => v >= 0 ||
							this.$t('form.validation.gt', {
								field: this.$t('form.label.ttl'),
								number: 0
							}),
					],
					type: "text",
				},
				{
					label: this.$t('form.label.address'),
					name: "address",
					tooltip: "tooltip.add_dns_record.address",
					hidden: selectedType != "A" && selectedType != "AAAA",
					rules: [
						(v) => !!v || this.$t('form.validation.required', {field: this.$t('form.label.address')}),
						(v) =>
							(v && v.length <= 255) ||
							this.$t('form.validation.maxLength', {
								field: this.$t('form.label.address'),
								length: 255
							}),
					],
					type: "text",
				},
				{
					label: this.$t('form.label.tag'),
					name: "tag",
					tooltip: "tooltip.add_dns_record.tag",
					hidden: selectedType != "CAA",
					type: "select",
					rules: [],
					options: [
						{
							label: this.$t('form.option.issue'),
							value: "issue",
						},
						{
							label: this.$t('form.option.issuewild'),
							value: "issuewild",
						},
						{
							label: this.$t('form.option.iodef'),
							value: "iodef",
						},
					],
				},
				{
					label: this.$t('form.label.value'),
					name: "value",
					tooltip: "tooltip.add_dns_record.value",
					hidden: selectedType != "CAA",
					rules: [],
					type: "text",
				},
				{
					label: this.$t('form.label.flag'),
					name: "flag",
					tooltip: "tooltip.add_dns_record.flag",
					hidden: selectedType != "CAA",
					rules: [],
					type: "checkbox",
				},
				{
					label: this.$t('form.label.cname'),
					name: "cname",
					tooltip: "tooltip.add_dns_record.cname",
					hidden: selectedType != "CNAME",
					rules: [],
					type: "text",
				},
				{
					label: this.$t('form.label.target'),
					name: "target",
					tooltip: "tooltip.add_dns_record.target",
					hidden: selectedType != "SRV",
					rules: [],
					type: "text",
				},
				{
					label: this.$t('form.label.weight'),
					name: "weight",
					tooltip: "tooltip.add_dns_record.weight",
					hidden: selectedType != "SRV",
					rules: [],

					type: "text",
				},
				{
					label: this.$t('form.label.port'),
					name: "port",
					tooltip: "tooltip.add_dns_record.port",
					hidden: selectedType != "SRV",
					rules: [],

					type: "text",
				},
				{
					label: this.$t('form.label.priority'),
					name: "priority",
					tooltip: "tooltip.add_dns_record.priority",
					hidden: selectedType != "SRV",
					rules: [],

					type: "text",
				},
				{
					label: this.$t('form.label.txt'),
					name: "txtdata",
					tooltip: "tooltip.add_dns_record.txtdata",
					hidden: selectedType != "TXT",
					rules: [],

					type: "textarea",
				},
				{
					label: this.$t('form.label.priority'),
					name: "preference",
					tooltip: "tooltip.add_dns_record.preference",
					hidden: selectedType != "MX",
					rules: [],

					type: "text",
				},
				{
					label: this.$t('form.label.destination'),
					name: "exchange",
					tooltip: "tooltip.add_dns_record.exchange",
					hidden: selectedType != "MX",
					rules: [],

					type: "text",
				},
				{
					label: this.$t('form.label.nameserver'),
					name: "nameserver",
					tooltip: "tooltip.add_dns_record.nameserver",
					hidden: selectedType != "NS",
					rules: [],
					type: "text",
				},
				{
					label: this.$t('form.label.pointer'),
					name: "pointer",
					tooltip: "tooltip.add_dns_record.pointer",
					hidden: selectedType != "PTR",
					rules: [],
					type: "text",
				},
				{
					label: this.$t('form.label.rdata'),
					name: "rdata",
					tooltip: "tooltip.add_dns_record.rdata",
					hidden: selectedType === "A"
						|| selectedType === "AAAA"
						|| selectedType === "CAA"
						|| selectedType === "CNAME"
						|| selectedType === "MX"
						|| selectedType === "SRV"
						|| selectedType === "TXT"
						|| selectedType === "NS"
						|| selectedType === "PTR"
					,
					rules: [],

					type: "text",
				},
			];

			if (this.service.dns_server_type == 'cloudflare') {
				fields.push({
					label: this.$t('form.label.proxy'),
					name: "proxied",
					tooltip: "tooltip.add_dns_record.proxy",
					hidden:
						selectedType != "A" &&
						selectedType != "AAAA" &&
						selectedType != "CNAME",
					type: "switch",
				});
			}
			return fields;
		},

		// ADD DNS RECORD

		showAddRecordModal() {
			this.resetModal();
			this.modalOptions.title = this.$t('heading.hosting.dns.modal.add.title');
			this.modalOptions.icon = "$plus";
			this.modalOptions.message = this.$t('heading.hosting.dns.modal.update.message', {zone: `<strong>${this.zone.name}</strong>`});
			this.modalOptions.buttons.unshift({
				label: this.$t('button.dns.add'),
				color: "primary",
				onclick: (modal) => {
					modal.$refs.form.validate() && this.addDnsRecord(modal.formValues);
				},
			});
			this.modalOptions.formFields = this.formFields("A");
			this.modalOptions.item = { type: "A", ttl: "14400", tag: "issue" };
			this.modalOptions.open = true;
		},
		addDnsRecord(formData) {
			this.modalOptions.persistent = true;
			this.modalOptions.submitting = true;
			this.modalOptions.submittingSuccess = "";
			this.modalOptions.submittingError = "";

			Api.post(
				`/services/${this.service.id}/dns/zones/${this.zone.id}/records`,
				formData
			)
				.then(() => {
					this.modalOptions.submittingSuccess = this.$t('notification.hosting.dns.add.success');
					this.highlightItem = {
						type: formData.type,
						name: formData.name.trim(),
					};
					this.reloadZoneRecords(this.zone);

					this.$store.dispatch("addAlert", {
						success: true,
						successMessage: this.modalOptions.submittingSuccess,
					});
					this.modalOptions.open = false;
				})
				.catch((error) => {
					this.modalOptions.submittingError = Api.getErrorMessage(error);

					this.$store.dispatch("addAlert", {
						success: false,
						errorMessage: this.modalOptions.submittingError,
					});
				})
				.finally(() => {
					this.modalOptions.persistent = false;
					this.modalOptions.submitting = false;
				});
		},

		// EDIT DNS RECORD

		showEditRecordModal(item) {
			this.resetModal();
			if (
				item.type == "TXT" &&
				item.txtdata &&
				item.txtdata.length >= 2 &&
				item.txtdata.charAt(0) == '"' &&
				item.txtdata.charAt(item.txtdata.length - 1) == '"'
			) {
				item.txtdata = item.txtdata.substring(1, item.txtdata.length - 1);
			}
			this.modalOptions.item = item;
			this.modalOptions.title = this.$t('heading.hosting.dns.modal.update.title');
			this.modalOptions.icon = "$edit";
			this.modalOptions.message = this.$t('heading.hosting.dns.modal.update.message', {zone: `<strong>${this.zone.name}</strong>`});
			this.modalOptions.buttons.unshift({
				label: this.$t('button.update'),
				color: "primary",
				onclick: (modal) => {
					modal.$refs.form.validate() &&
					this.updateDnsRecord(item, modal.formValues);
				},
			});
			this.modalOptions.formFields = this.formFields(item.type, true);
			this.modalOptions.open = true;
		},
		updateDnsRecord(item, formData) {
			this.modalOptions.persistent = true;
			this.modalOptions.submitting = true;
			this.modalOptions.submittingSuccess = "";
			this.modalOptions.submittingError = "";

			let dnsRecord = item.line === undefined ? item.Line : item.line;
			if (dnsRecord === undefined) {
				dnsRecord = item.name;
			}

			Api.put(
				`/services/${this.service.id}/dns/zones/${this.zone.id}/records/${dnsRecord}`,
				formData
			)
				.then(() => {
					this.modalOptions.submittingSuccess = this.$t('notification.hosting.dns.update.success');
					this.highlightItem = { type: item.type, name: formData.name };
					this.$store.dispatch("addAlert", {
						success: true,
						successMessage: this.modalOptions.submittingSuccess,
					});
					this.reloadZoneRecords(this.zone);
					this.modalOptions.open = false;
				})
				.catch((error) => {
					this.modalOptions.submittingError = Api.getErrorMessage(error);

					this.$store.dispatch("addAlert", {
						success: false,
						errorMessage: this.modalOptions.submittingError,
					});
				})
				.finally(() => {
					this.modalOptions.persistent = false;
					this.modalOptions.submitting = false;
				});
		},

		// DELETE DNS RECORD

		showDeleteRecordModal(item) {
			this.resetModal();
			this.modalOptions.item = item;
			this.modalOptions.title = this.$t('heading.hosting.dns.modal.delete.title');
			this.modalOptions.color = "error";
			this.modalOptions.icon = "$alertwarning";

			this.modalOptions.formFields = [
				{
					message: `<b>${this.$t('message.confirmAction')}</b>`,
					label: this.$t('form.confirmDelete.dns'),
					name: "confirm",
					type: "checkbox",
					required: true,
				},
			];

			this.modalOptions.buttons.unshift({
				label: this.$t('button.delete'),
				color: "error",
				onclick: (modal) => {
					modal.$refs.form.validate() && this.deleteDnsRecord(item);
				},
			});
			this.modalOptions.open = true;
		},
		deleteDnsRecord(item) {
			this.modalOptions.persistent = true;
			this.modalOptions.submitting = true;
			this.modalOptions.submittingSuccess = "";
			this.modalOptions.submittingError = "";

			let dnsRecord = item.line === undefined ? item.Line : item.line;
			if (dnsRecord === undefined) {
				dnsRecord = item.name + "?type=" + item.type;
			}

			Api.delete(
				`/services/${this.service.id}/dns/zones/${this.zone.id}/records/${dnsRecord}`
			)
				.then(() => {
					this.modalOptions.submittingSuccess = this.$t('notification.hosting.dns.delete.success');
					this.reloadZoneRecords(this.zone);

					this.$store.dispatch("addAlert", {
						success: true,
						successMessage: this.modalOptions.submittingSuccess,
					});
					this.modalOptions.open = false;
				})
				.catch((error) => {
					this.modalOptions.submittingError = Api.getErrorMessage(error);

					this.$store.dispatch("addAlert", {
						success: false,
						errorMessage: this.modalOptions.submittingError,
					});
				})
				.finally(() => {
					this.modalOptions.persistent = false;
					this.modalOptions.submitting = false;
				});
		},
	}
}